<template>
    <SimilarEmdFound
        v-if="step === Step.SIMILIAR_FILE_FOUND"
        v-bind="$props"
        v-model="selectedEmd"
        @confirm-no-merge="showConfirmDialog"
        @next-step="step = Step.MERGE_EMD_AND_FILE"
    />
    <MergeEmdAndFile
        v-else-if="step === Step.MERGE_EMD_AND_FILE && selectedEmd"
        v-bind="$props"
        :emd="selectedEmd"
        @confirm-no-merge="showConfirmDialog"
        @prev-step="step = Step.SIMILIAR_FILE_FOUND"
    />

    <dialog
        ref="confirmNoMergeDialogRef"
        class="fade-dialog-enter-exit relative rounded-xl pt-10 font-inter"
        @close="onConfirmDialogClose"
    >
        <form
            class="grid p-4 text-center"
            method="dialog"
        >
            <button
                class="absolute right-6 top-3 text-3xl shadow-none hover:opacity-50"
                value="cancel"
            >
                &times;
            </button>
            <strong class="text-lg font-semibold">Are you sure?</strong>
            <p>Are you sure you want to create a new file?</p>

            <DsButton
                class="mt-8"
                size="md"
                type="submit"
                :value="CONFIRM_NO_MERGE"
                variant="primary"
            >
                Yes, this is not a duplicate
            </DsButton>

            <DsButton
                class="mt-2"
                size="md"
                type="submit"
                value="cancel"
                variant="secondary"
            >
                Never mind
            </DsButton>
        </form>
    </dialog>
</template>

<script setup lang="ts">
import type { EarlyDeposit } from '@/api/interfaces/early-deposit.types';
import type { SimilarFilesProps } from '@/company-portal/add-view-file';
import DsButton from '@ds/button/DsButton.vue';
import { ref } from 'vue';
import MergeEmdAndFile from './MergeEmdAndFile.vue';
import SimilarEmdFound from './SimilarEmdFound.vue';

const CONFIRM_NO_MERGE = 'confirm-no-merge';
const enum Step {
    SIMILIAR_FILE_FOUND,
    MERGE_EMD_AND_FILE,
    SUMMARY,
}

const props = defineProps<
    SimilarFilesProps & {
        closeAndUnmount: () => void;
    }
>();

const step = ref<Step>(Step.SIMILIAR_FILE_FOUND);
const selectedEmd = ref<EarlyDeposit>();
const confirmNoMergeDialogRef = ref<HTMLDialogElement>();

const showConfirmDialog = () => {
    confirmNoMergeDialogRef.value?.showModal();
};

const onConfirmDialogClose = () => {
    if (confirmNoMergeDialogRef.value?.returnValue === CONFIRM_NO_MERGE) {
        props.submitFormWith();
        props.closeAndUnmount();
    }
};
</script>

<style scoped lang="scss">
@import '$sass/dialog-fading.scss';

.fade-dialog-enter-exit {
    --duration: 100ms;
}
</style>
